import React from 'react';
import { Link } from 'react-router-dom';

const CTA = () => {
    return (
        <section className="py-8 md:py-10">
            <div className="container-custom">
                <div className="rounded-[32px] border border-[var(--color-accent)]/20 bg-[var(--color-dark)] px-6 py-7 md:px-10 md:py-8 text-center shadow-2xl shadow-[var(--color-dark)]/10">
                    <h2 className="text-2xl md:text-3xl font-semibold mb-2 text-white">
                        Ready to start your project?
                    </h2>

                    <p className="text-white/80 max-w-2xl mx-auto mb-4 leading-relaxed">
                        Let’s build something strong, durable, and built to last with our steel fabrication expertise.
                    </p>

                    <Link
                        to="/contact"
                        className="btn-primary inline-flex items-center justify-center"
                    >
                        Contact Us
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default CTA;